import React from "react";
import { Box, Typography, Stack, Button, IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const makePath = (path) => `/${lang || "en"}${path}`;

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 4, md: 5 },
        px: 2,
        background: "#1e293b",
        color: "#fff",
        textAlign: "center"
      }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, fontWeight: "bold", fontSize: { xs: "1.1rem", md: "1.3rem" } }}
      >
        {t("ready_to_start") || "Ενδιαφέρεσαι για συνεργασία;"}
      </Typography>

      <Button
        variant="contained"
        color="secondary"
        size="large"
        component={Link}
        to={makePath("/contact")}
        sx={{ mb: 3, borderRadius: 4, fontWeight: "bold" }}
      >
        {t("contact_us") || "Επικοινώνησε μαζί μας"}
      </Button>

      {/* Social Icons */}
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        useFlexGap
        flexWrap="wrap"
        sx={{ mb: 3 }}
      >
        <IconButton
          component="a"
          href="mailto:info@brainstorm-visions.com"
          color="secondary"
          aria-label="Send Email"
        >
          <EmailIcon />
        </IconButton>
        <IconButton
          component="a"
          href="https://facebook.com/BrainstormVisions"
          color="secondary"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit Facebook page"
        >
          <FacebookIcon />
        </IconButton>
        <IconButton
          component="a"
          href="https://wa.me/306989690247"
          color="secondary"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Send WhatsApp message"
        >
          <WhatsAppIcon />
        </IconButton>
      </Stack>

      {/* Contact Info */}
      <Typography variant="body2" sx={{ mt: 1 }}>
        {t("address") || "Διεύθυνση"}: 1908 Thomes Ave STE 12392, Cheyenne, WY 82001, USA
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {t("company_ein")} | info@brainstorm-visions.com | +30 6989 690247
      </Typography>

      {/* Privacy Policy */}
      <Box sx={{ my: 2 }}>
        <Link
          to={`/${i18n.language}/privacy-policy`}
          style={{ color: "#fff", textDecoration: "underline", fontSize: "0.9rem" }}
        >
          {t("privacy.privacy") || "Πολιτική Απορρήτου"}
        </Link>
        <Link
          to={`/${i18n.language}/terms`}
          style={{ color: "#fff", textDecoration: "underline", fontSize: "0.9rem", marginLeft: 12 }}
        >
          {t("footer.terms") || "Όροι Χρήσης"}
        </Link>
      </Box>

      {/* Copyright */}
      <Typography variant="caption" color="grey.400">
        &copy; {new Date().getFullYear()} BrainstormVisions. {t("all_rights_reserved") || "Όλα τα δικαιώματα διατηρούνται."}
      </Typography>
    </Box>
  );
};

export default Footer;
